//imports
import {
    SYNC_CTC_INFORMATION_OPEN_MODAL,
    SYNC_CTC_INFORMATION_REQUEST,
    SYNC_CTC_INFORMATION_RESULT,
    CLEAR_REDUX,
} from 'Redux/actionTypes';

//initial values
const INIT_STATE = {
    openModal: false,
    loading: false,
    result: null,
};


//change redux object
export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case SYNC_CTC_INFORMATION_OPEN_MODAL:
            return { ...state, openModal: action.payload.open }

        case SYNC_CTC_INFORMATION_REQUEST:
            return { ...state, loading: true }

        case SYNC_CTC_INFORMATION_RESULT:
            return { ...state, loading: false, result: action.payload.data }

        case CLEAR_REDUX:
            return ["", "SYNC_CTC_INFORMATION"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INIT_STATE }
                : { ...state };

        default:
            return state;
    }
};